import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

export function Header() {
    return (
        <Stack spacing={16}>
            <Body isBold={true} size='large'>
                Engagement bar actions
            </Body>
            <Body color='dark'>
                Set up each action for the engagement bar below and{' '}
                <Body isBold={true}>
                    specify which ones should be visible under the ‘Engagement bar’ tab.
                </Body>
            </Body>
        </Stack>
    );
}
